import { RouteConfig } from 'vue-router';

import Search from '~/views/Search';

const config: RouteConfig = {
  component: Search,
  path: 'destinations',
  name: 'All destinations',
};

export default config;
